import React, { useState, useEffect } from "react";
import Button from "../../Button";
import apiInstance from "../../apiInstance";

const EditWebsitePopup = ({
    data,
    type = "update",
    updateWebsite,
    updateError,
    closePopup,
}) => {
    const [website, setWebsite] = useState({
        id: data?.website?._id || "",
        name: data?.website?.name || "",
        note: data?.website?.note || "",
        siteUrl: data?.website?.siteUrl || '',
        owner_id: data?.website?.owner_id?._id || "",
        status: data?.website?.status || ""
    });

    const [fieldErrors, setFieldErrors] = useState({});
    const [users, setUsers] = useState([]); 

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setWebsite((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = () => {
        const apiCall =
            type === "update"
                ? apiInstance.put(`/devadmin/website/${website.id}`, website)
                : apiInstance.post(`/devadmin/website`, website);

        apiCall
            .then((response) => {
                const returnedWebsite = response.data.website;
                const counts = response.data.counts;
                if (type === "update") {
                    updateWebsite(returnedWebsite, counts);
                } else {
                    // addWebsite(returnedWebsite);
                }
                closePopup();
            })
            .catch((error) => {
                console.log(error);
                if (error.response) {
                    if (
                        error.response.status === 400 &&
                        error.response.data.fieldErrors
                    ) {
                        setFieldErrors(error.response.data.fieldErrors);
                    } else {
                        updateError(error.response.data.message || 'Something went wrong, please try again later.');
                    }
                } 
            });
    };

    useEffect(() => {
        apiInstance
            .get("/devadmin/user")
            .then((res) => {
                setUsers(res.data.users || []);
            })
            .catch((err) => {
                console.error("Error fetching users:", err);
                updateError("Failed to load users.");
            });
    }, [updateError]);

    return (
        <div className="mjsdev-pp">
            <h2>{type === "add" ? "ADD WEBSITE" : "EDIT WEBSITE"}</h2>

            <form>
                <div className="mjsdev-input-field">
                    <label htmlFor="name">Site Name</label>
                    <input
                        type="text"
                        placeholder="Site Name"
                        name="name"
                        value={website.name}
                        onChange={handleInputChange}
                    />
                    {fieldErrors.name && (
                        <span className="mjsdev-error">{fieldErrors.name}</span>
                    )}
                </div>

                <div className="mjsdev-input-field">
                    <label htmlFor="siteUrl">Site URL</label>
                    <input
                        type="text"
                        placeholder="Site URL"
                        name="siteUrl"
                        value={website.siteUrl}
                        onChange={handleInputChange}
                    />
                    {fieldErrors.siteUrl && (
                        <span className="mjsdev-error">
                            {fieldErrors.siteUrl}
                        </span>
                    )}
                </div>

                <div className="mjsdev-input-field">
                    <label htmlFor="owner_id">Owner</label>
                    <select
                        name="owner_id"
                        value={website.owner_id}
                        onChange={handleInputChange}
                    >
                        <option value="">Select Owner</option>
                        {users.map((user) => (
                            <option key={user._id} value={user._id}>
                                {user.email}
                            </option>
                        ))}
                    </select>
                    {fieldErrors.owner_id && (
                        <span className="mjsdev-error">
                            {fieldErrors.owner_id}
                        </span>
                    )}
                </div>

                <div className="mjsdev-input-field">
                    <label htmlFor="status">Status</label>
                    <select
                        name="status"
                        value={website.status}
                        onChange={handleInputChange}
                    >
                        <option value="">Select Status</option>
                        <option value="in_queue">In Queue</option>
                        <option value="generated">Generated</option>
                        <option value="interested">Interested</option>
                        <option value="claimed">Claimed</option>
                        <option value="paused">Paused</option>
                    </select>
                    {fieldErrors.status && (
                        <span className="mjsdev-error">
                            {fieldErrors.status}
                        </span>
                    )}
                </div>

                <div className="mjsdev-input-field">
                    <label htmlFor="note">Note</label>
                    <textarea
                        name="note"
                        value={website.note}
                        onChange={handleInputChange}
                    >
                        {website.note}
                    </textarea>
                </div>
            </form>

            <div className="mjsdev-pp-actions">
                <Button
                    name={type === "add" ? "Add" : "Update"}
                    eventHandler={handleSubmit}
                />
                <Button name="Cancel" eventHandler={closePopup} />
            </div>
            
        </div>
    );
};

export default EditWebsitePopup;
